import { render, staticRenderFns } from "./SystemSettingsItem.vue?vue&type=template&id=36b4dde2&scoped=true&"
import script from "./SystemSettingsItem.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4dde2",
  null
  
)

export default component.exports